export default {"src":"/_next/static/media/light-grey-right.55c85f9f.svg","height":220,"width":1920,"blurWidth":0,"blurHeight":0};